import { useAccount, useContractRead, useNetwork } from 'wagmi';
import { Abi } from 'viem';
import { motion } from 'framer-motion';
import { ADDRESSES, CONFIG, CHAIN_ID } from '../config';
import { formatTokenAmount } from '../utils/formatting';

export function AssetsList() {
  const { address } = useAccount();
  const { chain } = useNetwork();

  // Get token balances
  const { data: trinityBalance = 0n } = useContractRead({
    address: ADDRESSES.TRINITY_TOKEN,
    abi: CONFIG.ERC20_ABI.abi as Abi,
    functionName: 'balanceOf',
    args: [address],
    enabled: !!address && chain?.id === CHAIN_ID,
    watch: true,
  });

  const { data: fedBalance = 0n } = useContractRead({
    address: ADDRESSES.FED,
    abi: CONFIG.ERC20_ABI.abi as Abi,
    functionName: 'balanceOf',
    args: [address],
    enabled: !!address && chain?.id === CHAIN_ID,
    watch: true,
  });

  const { data: tbillBalance = 0n } = useContractRead({
    address: ADDRESSES.TBILL,
    abi: CONFIG.ERC20_ABI.abi as Abi,
    functionName: 'balanceOf',
    args: [address],
    enabled: !!address && chain?.id === CHAIN_ID,
    watch: true,
  });

  const { data: pdaiBalance = 0n } = useContractRead({
    address: ADDRESSES.PDAI,
    abi: CONFIG.ERC20_ABI.abi as Abi,
    functionName: 'balanceOf',
    args: [address],
    enabled: !!address && chain?.id === CHAIN_ID,
    watch: true,
  });

  const { data: couponBalance = 0n } = useContractRead({
    address: ADDRESSES.COUPON_TOKEN,
    abi: CONFIG.ERC20_ABI.abi as Abi,
    functionName: 'balanceOf',
    args: [address],
    enabled: !!address && chain?.id === CHAIN_ID,
    watch: true,
  });

  const assets = [
    { name: 'Trinity', balance: trinityBalance as bigint, symbol: '†' },
    { name: 'FED', balance: fedBalance as bigint, symbol: 'FED' },
    { name: 'TBill', balance: tbillBalance as bigint, symbol: 'TBILL' },
    { name: 'pDAI', balance: pdaiBalance as bigint, symbol: 'pDAI' },
    { name: 'Coupon', balance: couponBalance as bigint, symbol: 'COUPON' },
  ];

  if (!address) {
    return (
      <div className="text-center py-10">
        Please connect your wallet to view your assets.
      </div>
    );
  }

  return (
    <>
      <motion.div
        className="relative overflow-hidden rounded-2xl p-8 bg-gradient-to-br from-blue-500/20 via-indigo-500/20 to-purple-500/20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
      <h2 className="text-2xl font-bold mb-6 text-white">Assets</h2>
      <div className="space-y-4">
          {assets.map((asset) => (
            <motion.div
              key={asset.name}
              className="glass-panel p-6 rounded-lg relative overflow-hidden"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
            >
              {/* Gradient background */}
              <div className="absolute inset-0 opacity-10 bg-gradient-to-r from-blue-500/50 to-purple-500/50" />
              
              {/* Content container */}
              <div className="relative z-10 flex flex-col">
                {/* Asset name and symbol */}
                <div className="flex items-baseline gap-2 mb-1">
                  <h3 className="text-lg font-medium text-white">{asset.name}</h3>
                  <span className="text-sm text-gray-400">{asset.symbol}</span>
                </div>
                
                {/* Balance */}
                <div className="text-2xl font-bold text-white">
                  {formatTokenAmount(asset.balance)}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </>
  );
} 